import { useState, useRef, useCallback, memo } from 'react'
import { cn } from '@/shared/lib/utils'
import { useTelegram } from '@/shared/lib/telegram'

const AMOUNTS = [500, 1000, 2000, 3000, 5000, 10000]

interface AmountSelectorProps {
  value: number
  onChange: (amount: number) => void
}

export const AmountSelector = memo(function AmountSelector({ value, onChange }: AmountSelectorProps) {
  const { hapticFeedback } = useTelegram()
  const [customText, setCustomText] = useState('')
  const [isCustom, setIsCustom] = useState(false)

  const handlePresetClick = useCallback((amount: number) => {
    hapticFeedback.impactOccurred('light')
    setIsCustom(false)
    setCustomText('')
    onChange(amount)
  }, [hapticFeedback, onChange])

  const handleCustomChange = useCallback((val: string) => {
    setCustomText(val)
    setIsCustom(true)
    const num = Number(val)
    // Обновляем сразу — MainButton покажет актуальную сумму
    onChange(num >= 500 ? num : 0)
  }, [onChange])

  return (
    <div>
      {/* Chips */}
      <div className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1 scrollbar-none">
        {AMOUNTS.map((amount) => (
          <button
            key={amount}
            type="button"
            onClick={() => handlePresetClick(amount)}
            className={cn(
              'shrink-0 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all border',
              !isCustom && value === amount
                ? 'bg-[var(--tg-theme-button-color,#1A1A1A)] text-[var(--tg-theme-button-text-color,#FFFFFF)] border-transparent'
                : 'bg-[var(--tg-theme-bg-color,#FFFFFF)] text-[var(--tg-theme-text-color,#1A1A1A)] border-[var(--tg-theme-hint-color,#999999)]/30'
            )}
          >
            {amount >= 1000 ? `${amount / 1000}K` : amount}
          </button>
        ))}
      </div>

      {/* Custom input */}
      <input
        type="number"
        inputMode="numeric"
        value={customText}
        onFocus={() => setIsCustom(true)}
        onChange={(e) => handleCustomChange(e.target.value)}
        placeholder="Другая сумма (от 500 ₽)"
        min={500}
        className={cn(
          'w-full mt-2 px-4 py-3 rounded-xl border text-sm outline-none transition-all',
          'bg-[var(--tg-theme-secondary-bg-color,#F5F5F5)] text-[var(--tg-theme-text-color,#1A1A1A)]',
          'placeholder:text-[var(--tg-theme-hint-color,#999999)]',
          isCustom
            ? 'border-[var(--tg-theme-button-color,#1A1A1A)] ring-1 ring-[var(--tg-theme-button-color,#1A1A1A)]/10'
            : 'border-[var(--tg-theme-hint-color,#999999)]/30'
        )}
      />
    </div>
  )
})
